import { render, staticRenderFns } from "./modulepay.vue?vue&type=template&id=34956124&scoped=true"
import script from "./modulepay.vue?vue&type=script&lang=js"
export * from "./modulepay.vue?vue&type=script&lang=js"
import style0 from "./modulepay.vue?vue&type=style&index=0&id=34956124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34956124",
  null
  
)

export default component.exports